import React from 'react';
import Collapsible from 'react-collapsible';
import { Hint } from '../hint/hint';
import { ArrowDown } from '@tpr/icons';
import Styles from './helplink.module.scss';
export var HelpLink = function (props) {
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var Trigger = function () { return (React.createElement("button", { "aria-expanded": expanded, "data-gtm": "helpLink" },
        React.createElement(ArrowDown, null),
        props.title)); };
    var _b = React.useState(), accessibleAlert = _b[0], setAccessibleAlert = _b[1];
    function createAccessibleAlert() {
        return (React.createElement("p", { role: "alert", className: Styles.visuallyHidden }, expanded ? 'collapsed' : 'expanded'));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Collapsible, { trigger: React.createElement(Trigger, null), classParentString: (Styles.helpLink + " " + props.className).trim(), contentInnerClassName: (Styles.helpLinkContent + " " + props.contentClassName).trim(), overflowWhenOpen: "visible", onOpening: function () {
                setExpanded(true);
                setAccessibleAlert(createAccessibleAlert());
            }, onClosing: function () {
                setExpanded(false);
                setAccessibleAlert(createAccessibleAlert());
            } },
            React.createElement(Hint, { expanded: expanded }, props.children)),
        accessibleAlert));
};
//# sourceMappingURL=helplink.js.map